/**
 * PrimeNG became a commercial product in v22 and shows an "Invalid PrimeUI License"
 * banner without a registered key. This is the Community (free tier) key.
 *
 * Verification is offline (Ed25519), so the key ships in the client bundle by design.
 * Tier: community / dev — expires 2027-08-27, renew at https://primeui.dev before then.
 */
export const PRIMENG_LICENSE_KEY =
  'eyJpZCI6IjZjNTMyMDFhLTY3NTktNDBjMS05MTE5LTk1NmE3Nzc0OTFiZiIsInByb2R1Y3QiOiJwcmltZXVpIiwidGllciI6ImNvbW11bml0eSIsInR5cGUiOiJkZXYiLCJpYXQiOjE3ODc3OTA3ODgsImV4cCI6MTgxOTMyNjc4OH0.30tOJU01CFsKMuAL-l_0Gh41V3wZnNFg49fMa2uayiGHC3edS6gZ3oZGPoneXS39ajGO4U-fsFnRgfYpHNURDQ';
